import { TEAM_GROUP_HOLDER_ROLE, TEAM_COACH_ROLE } from '@client/config/team';

export const isGroupHolder = (role) => role === TEAM_GROUP_HOLDER_ROLE;

export const isCoach = (role) => role === TEAM_COACH_ROLE;
